module.exports = "<ul>\r\n    <li class=\"header-menu-main\" *ngFor=\"let item of items\">\r\n        <header-menu-item [item]=\"item\"></header-menu-item>\r\n    </li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header-menu/header-menu.component.html
// module id = ./src/app/shared/header-menu/header-menu.component.html
// module chunks = main